import React, { useState } from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Box, Flex } from '@components/layout/Grid';
import SearchFiltersModal from '@organisms/modals/SearchFiltersModal';
import { SelectedTermsComponent } from './SelectedTerms';
import {
  NewTaxonomyItemFieldsFragment,
  TaxonomyItem,
  Term,
} from '@gql/generated';
import VideoSettings from '@ecosystems/VideoSettings';
import { FullTaxonomiesModal } from './FullTaxonomiesModal';
import { SlidersHorizontal } from 'lucide-react';

const SelectedTerms = styled.div`
  overflow: hidden;
`;

const Button = styled.button`
  color: rgba(36, 36, 36, 1);
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  border: none;
  cursor: pointer;

  i {
    margin: 0 5px;
  }
`;

const Bar = styled(Flex)<{ open: boolean }>`
  border-radius: 4px;
  background-color: rgba(241, 241, 241, 1);

  ${({ open }) =>
    open
      ? `
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      `
      : ''}
`;

type Props = {
  selectedTerms: Record<string, string[]>;
  taxonomies: NewTaxonomyItemFieldsFragment[];
  handleSelectTerm(term: Term, slug: string): void;
  selectedTaxonomySlug(): void;
  handleSelectTaxonomy(taxonomyItem: TaxonomyItem): void;
  clearAll(): void;
  clearTaxonomy(slug: string): void;
};

export const TaxonomiesFiltersMobile = (props: Props) => {
  const {
    selectedTerms,
    taxonomies,
    selectedTaxonomySlug,
    handleSelectTaxonomy,
    handleSelectTerm,
    clearAll,
    clearTaxonomy,
  } = props;
  const [openFiltersModal, setOpenFilters] = useState(false);
  const [isSettingsModalOpen, openSettingsModal] = useState(false);

  const totalTermsSelected = Object.values(selectedTerms).reduce(
    (acc, group) => acc + group.length,
    0
  );

  return (
    <React.Fragment>
      <Box width={1}>
        <Bar justifyContent="space-between" py={19} px={13}>
          <Button
            className="flex items-center gap-1"
            onClick={() => setOpenFilters(!openFiltersModal)}
          >
            <SlidersHorizontal className="size-4" />
            <Trans id="videos_genres.filters_mobile_button" />{' '}
            {totalTermsSelected > 0 ? `(${totalTermsSelected})` : ''}
          </Button>
          <VideoSettings
            button_text={<Trans id="videos_genres.settings_button_mobile" />}
          />
        </Bar>
        {openFiltersModal ? (
          <FullTaxonomiesModal
            selectedTerms={selectedTerms}
            taxonomies={taxonomies}
            handleSelectTerm={handleSelectTerm}
            clearAll={clearAll}
            clearTaxonomy={clearTaxonomy}
            onClose={() => setOpenFilters(false)}
          />
        ) : null}
      </Box>
      <Flex as={SelectedTerms} mr={-20}>
        <SelectedTermsComponent
          selectedTerms={selectedTerms}
          taxonomies={taxonomies}
          handleSelectTerm={handleSelectTerm}
          clearAll={clearAll}
        />
      </Flex>
      {/* Modal */}
      <SearchFiltersModal
        taxonomies={taxonomies}
        selectedTaxonomySlug={selectedTaxonomySlug}
        open={isSettingsModalOpen}
        handleClose={() => {
          openSettingsModal(false);
          handleSelectTaxonomy(null);
        }}
        handleClickTerm={handleSelectTerm}
        clearAll={clearAll}
      />
    </React.Fragment>
  );
};
